import { Constants } from 'src/app/helper/constants';

export const GET_SITE_REQUEST_DETAILS = Constants.HSE_BASE_URL + '/siterequests/request';
